import Email from "../components/configuration/email/Email";

const EmailPage = () => {
    return(
        <Email/>
    )
}

export default EmailPage;